export const formatDuration = (ms: number | null) => {
  if (ms == null || ms < 0) return '—';
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ${min % 60}m`;
  const day = Math.floor(hr / 24);
  return `${day}d ${hr % 24}h ${min % 60}m`;
};

export const formatRelative = (iso: string | null) => {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return 'now';
  return `${formatDuration(ms)} ago`;
};

export const formatSeconds = (ms: number | null) =>
  ms == null ? '—' : `${(ms / 1000).toFixed(1)}s`;
